
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $fc029b301036bda2$exports = {};

$parcel$export($fc029b301036bda2$exports, "is-disabled", function () { return $fc029b301036bda2$export$d35bc1e505d1ebbf; }, function (v) { return $fc029b301036bda2$export$d35bc1e505d1ebbf = v; });
$parcel$export($fc029b301036bda2$exports, "spectrum-Avatar", function () { return $fc029b301036bda2$export$2e049b8d031600fb; }, function (v) { return $fc029b301036bda2$export$2e049b8d031600fb = v; });
var $fc029b301036bda2$export$d35bc1e505d1ebbf;
var $fc029b301036bda2$export$2e049b8d031600fb;
$fc029b301036bda2$export$d35bc1e505d1ebbf = `jilAbW_is-disabled`;
$fc029b301036bda2$export$2e049b8d031600fb = `jilAbW_spectrum-Avatar`;


export {$fc029b301036bda2$exports as default};
//# sourceMappingURL=avatar_vars_css.mjs.map
